export const OBJECTSTORE_ROQ_CODE_CATEGORIES = "RoqCodeCategories";
export const OBJECTSTORE_ROQ_CODES = "RoqCodes";